import { QuestionForm } from "@/pages/campaign-form/components/campaigns/personalizedMessages/components/CustomQuestions/CreateQuestionModal"
import { formatDataToSubmit } from "@/pages/campaign-form/components/campaigns/personalizedMessages/components/CustomQuestions/CreateQuestionModal.helper"
import { questionTypes } from "@/pages/campaign-form/components/campaigns/personalizedMessages/components/CustomQuestions/QuestionCreateUpdateForm/QuestionCreateUpdateForm"

type OptionNew = {
    order: number
    value: string
    archived: boolean
    slug: string
}

const { TagType } = DjangIO.app.person.types

export const DEFAULT_VALUES = {
    name: "",
    tag_type: TagType.string.value,
    add_as_custom_field: false,
    required: false,
    default_multi_value: null,
    default_string_value: "",
    default_boolean_value: null,
    options_new: [],
}

export const getDefaultValues = (question: QuorumModel["CustomTag"]): QuestionForm => {
    const options_new = []
    if (question?.options_new)
        Object.keys(question.options_new).forEach((key, index) => {
            const option = question.options_new[key] as unknown as OptionNew
            options_new.push({
                order: index,
                value: option?.value,
                archived: false,
                slug: key.split("_")[1],
            })
        })

    return {
        name: question?.name ?? "",
        required: question?.is_required ?? false,
        default_multi_value: question?.default_multi_value ?? null,
        default_string_value: question?.default_string_value ?? "",
        default_boolean_value: question?.default_boolean_value ?? null,
        options_new: options_new,
        tag_type: (question?.tag_type as (typeof questionTypes)[number]["value"]) ?? TagType.string.value,
        add_as_custom_field: question?.display_on_profile ?? false,
    }
}

const UNDESIRED_UPDATE_KEYS = ["organization", "tag_owner", "tag_type", "is_editable"]

export const getUpdatedValuesToSubmit = (data: QuestionForm): Partial<QuorumModel["CustomTag"]> => {
    const values = formatDataToSubmit(data)
    UNDESIRED_UPDATE_KEYS.forEach((key) => delete values[key])
    return values
}
